export default function ({ route, env }) {
  if (process.client) {
    // 百度统计
    _hmt.push(['_trackPageview', route.path])
  }
}
